import { Scene } from "phaser";
import { ElementView } from "../ElementView";

export abstract class UIView extends ElementView {
    x1: number;
    y1: number;
    x2: number;
    y2: number;

    constructor(scene: Scene, type: string, x1: number, y1: number, x2: number, y2: number,) {
        super (scene, type, x1, y1);
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
}